/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const STEP_MODEL = {
    COMPLETE: {
        TOTAL: 4,
        NAME: 'COMPLETE'
    },
}
